<template>
  <div class="orderHomepage-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <div class="card-title">
            建店信息
          </div>
          <div v-loading="loading" class="card-content">
            <div class="order-info">
              <span class="tit">项目名称：</span>
              <span>{{ dataDetail.name }}</span>
              <span class="tit mf">创建人：</span>
              <span style="color:#409EFF;font-weight: 500">{{ dataDetail.createname }}</span>
              <span class="tit mf">状态：</span>
              <span v-if="dataDetail.mark===0">平面图</span>
              <span v-if="dataDetail.mark===1">效果图 </span>
              <span v-if="dataDetail.mark===2">施工图</span>
              <span v-if="dataDetail.mark===3">施工交底 </span>
              <span v-if="dataDetail.mark===4">复尺</span>
              <span v-if="dataDetail.mark===5">深化图纸</span>
              <span v-if="dataDetail.mark===6">下单</span>
              <span v-if="dataDetail.mark===9">验收</span>
              <span v-if="dataDetail.mark===100">已完成</span>
            </div>
            <div class="order-info">
              <span class="tit">经销商：</span>
              <span>{{ dataDetail.allname }}</span>
              <span class="tit mf">经销商电话：</span>
              <span>{{ dataDetail.tel }}</span>
            </div>
            <div class="order-info">
              <span class="tit">所在城市：</span>
              <span>{{ dataDetail.province }}-{{ dataDetail.city }}-{{ dataDetail.county }}</span>
              <span class="tit mf">专卖店地址：</span>
              <span v-if="dataDetail.address!==null&&dataDetail.address!==''&&dataDetail.address!==undefined" >{{ dataDetail.address }}</span>
              <span v-if="dataDetail.address===null||dataDetail.address===''||dataDetail.address===undefined" >N/A</span>
              <span class="tit mf">专卖店面积：</span>
              <span v-if="dataDetail.storearea!==null&&dataDetail.storearea!==''&&dataDetail.storearea!==undefined" >{{ dataDetail.storearea }}/㎡</span>
              <span v-if="dataDetail.storearea===null||dataDetail.storearea===''||dataDetail.storearea===undefined" >N/A</span>
            </div>
          </div>
        </div>
      </el-col>
      <el-col class="card mt" v-if="dataDetail.mark>=6">
        <div class="card-body">
          <div class="card-title">
            关联订单
          </div>
          <div class="card-content" v-loading="orderDataLoading">
            <el-table
              :data="orderTableData"
              stripe
              :row-style="{cursor: 'pointer'}"
              @row-click="openDetails"
              style="width: 100%">
              <el-table-column
                label="订单号"
                width="120"
                fixed
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span>{{scope.row.ordernum}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="生产单号"
                width="120"
                fixed
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span style="font-weight: 500;color:#409EFF" v-if="scope.row.produnum!==null&&scope.row.produnum!==''&&scope.row.produnum!==undefined">{{scope.row.produnum}}</span>
                  <span style="font-weight: 500;color:#999999" v-if="scope.row.produnum===null||scope.row.produnum===''||scope.row.produnum===undefined">N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="delname"
                label="经销商"
                align="center"
                width="120"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="订单类型"
                width="110"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-if="scope.row.type===0">正单</span>
                  <span v-if="scope.row.type===1">客改单</span>
                  <span v-if="scope.row.type===2">增补单</span>
                  <span v-if="scope.row.type===3">色板单</span>
                  <span v-if="scope.row.type===4">售后单</span>
                </template>
              </el-table-column>
              <!--<el-table-column
                label="品牌"
                width="130"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <span style="color:#99a9bf">品牌：</span>
                  <span>{{scope.row.brandname}}</span>
                </template>
              </el-table-column>-->
              <el-table-column
                prop="time"
                label="上次操作时间"
                width="170"
                align="center"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="拆单人员"
                align="center"
                width="120">
                <template slot-scope="scope">
                  <span v-if="scope.row.splitName!==''&&scope.row.splitName!==null">{{ scope.row.splitName }}</span>
                  <span v-if="scope.row.splitName===''||scope.row.splitName===null" style="color: #99a9bf;">N/A</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="address"
                label="详细地址"
                min-width="200"
                show-overflow-tooltip>
              </el-table-column>
              <el-table-column
                label="当前状态"
                fixed="right"
                width="100"
                align="center"
                show-overflow-tooltip>
                <template slot-scope="scope">
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===2" type="danger">售后驳回</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===3" type="danger">评估驳回</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===4" type="danger">确认驳回</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===5" type="danger">报价驳回</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===6" type="danger">预付驳回</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===7" type="danger">工厂拒接</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.dismark===8" type="danger">审单驳回</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===2&&scope.row.dismark===0" type="warning">待接单</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===3" class="tcf-tag-1">售后处理</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===4" class="tcf-tag-5">技术评估</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===5" class="tcf-tag-4">拆单分配</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===6&&scope.row.dismark===0" class="tcf-tag-2">待拆单</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===7&&scope.row.dismark===0" class="tcf-tag-6">订单确认</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===8&&scope.row.dismark===0" class="tcf-tag-3">待报价</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===9&&scope.row.dismark===0" class="tcf-tag-9">预付款</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===10&&scope.row.dismark===0" class="tcf-tag-7">工厂分派</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===11" class="tcf-tag-8">工厂接单</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===12" class="tcf-tag-10">订单排产</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===13" class="tcf-tag-11">订单生产</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===88" class="tcf-tag-1">待审单</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===99">已取消</el-tag>
                  <el-tag :disable-transitions="true" size="mini" v-if="scope.row.mark===100">已完成</el-tag>
                </template>
              </el-table-column>
              <el-table-column
                width="100"
                fixed="right"
                align="center"
                label="操作">
                <template>
                  <span style="font-size: 13px;color:#99a9bf">订单详情 <i class="el-icon-d-arrow-right"></i></span>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              v-if="ordertotal>0"
              background
              @size-change="orderHandleSizeChange"
              @current-change="orderHandleCurrentChange"
              :current-page="ordercurrentPage"
              :page-sizes="[20, 50, 100]"
              :page-size="orderpageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="ordertotal">
            </el-pagination>
          </div>
        </div>
      </el-col>
      <el-col class="card mt">
        <div class="card-body">
          <div class="card-title">
            建店跟踪
          </div>
          <div class="card-content">
            <el-row>
              <el-col :span="7">
                <el-timeline style="padding: 10px" class="order-track">
                  <el-timeline-item
                    :type="dataDetail.mark>=0?'primary':''"
                    size="large"
                    :timestamp="dataDetail.pmtime"
                  >
                    平面图 <span v-if="dataDetail.pmNo!==null&&dataDetail.pmNo!==''&&dataDetail.pmNo!==undefined&&dataDetail.pmNo!==0" style="margin-left: 10px"><el-tag type="danger" size="mini">待确认{{dataDetail.pmNo}}</el-tag></span>
                    <div style="margin-top: 6px;font-size: 12px;">{{ dataDetail.pmname }}</div>
                  </el-timeline-item>
                  <el-timeline-item
                    :type="dataDetail.mark>=1?'primary':''"
                    size="large"
                    :timestamp="dataDetail.xgtime"
                  >
                    效果图 <span v-if="dataDetail.xgNo!==null&&dataDetail.xgNo!==''&&dataDetail.xgNo!==undefined&&dataDetail.xgNo!==0" style="margin-left: 10px"><el-tag type="danger" size="mini">待确认{{dataDetail.xgNo}}</el-tag></span>
                    <div style="margin-top: 6px;font-size: 12px;">{{ dataDetail.sgname }}</div>
                  </el-timeline-item>
                  <el-timeline-item
                    :type="dataDetail.mark>=2?'primary':''"
                    size="large"
                    :timestamp="dataDetail.sgtime"
                  >
                    施工图 <span v-if="dataDetail.sgNo!==null&&dataDetail.sgNo!==''&&dataDetail.sgNo!==undefined&&dataDetail.sgNo!==0" style="margin-left: 10px"><el-tag type="danger" size="mini">待确认{{dataDetail.sgNo}}</el-tag></span>
                    <div style="margin-top: 6px;font-size: 12px;">{{ dataDetail.sgname }}</div>
                  </el-timeline-item>
                  <el-timeline-item
                    :type="dataDetail.mark>=3?'primary':''"
                    size="large"
                    :timestamp="dataDetail.sgjdtime"
                  >
                    施工交底 <span v-if="dataDetail.sgjdNo!==null&&dataDetail.sgjdNo!==''&&dataDetail.sgjdNo!==undefined&&dataDetail.sgjdNo!==0" style="margin-left: 10px"><el-tag type="danger" size="mini">待确认{{dataDetail.sgjdNo}}</el-tag></span>
                    <div style="margin-top: 6px;font-size: 12px;">{{ dataDetail.sgjdname }}</div>
                  </el-timeline-item>
                  <el-timeline-item
                    :type="dataDetail.mark>=4?'primary':''"
                    size="large"
                    :timestamp="dataDetail.fctime"
                  >
                    复尺 <span v-if="dataDetail.fcNo!==null&&dataDetail.fcNo!==''&&dataDetail.fcNo!==undefined&&dataDetail.fcNo!==0" style="margin-left: 10px"><el-tag type="danger" size="mini">待确认{{dataDetail.fcNo}}</el-tag></span>
                    <div style="margin-top: 6px;font-size: 12px;">{{ dataDetail.fcname }}</div>
                  </el-timeline-item>
                  <el-timeline-item
                    :type="dataDetail.mark>=5?'primary':''"
                    size="large"
                    :timestamp="dataDetail.shtztime"
                  >
                    深化图纸 <span v-if="dataDetail.shtzNo!==null&&dataDetail.shtzNo!==''&&dataDetail.shtzNo!==undefined&&dataDetail.shtzNo!==0" style="margin-left: 10px"><el-tag type="danger" size="mini">待确认{{dataDetail.shtzNo}}</el-tag></span>
                    <div style="margin-top: 6px;font-size: 12px;">{{ dataDetail.shtzname }}</div>
                  </el-timeline-item>
                  <el-timeline-item
                    :type="dataDetail.mark>=6?'primary':''"
                    size="large"
                  >
                    下单
                  </el-timeline-item>
                  <el-timeline-item
                    :type="dataDetail.mark>=9?'primary':''"
                    size="large"
                    :timestamp="dataDetail.ystime"
                  >
                    验收
                    <div style="margin-top: 6px;font-size: 12px;">{{ dataDetail.ysname }}</div>
                  </el-timeline-item>
                </el-timeline>
              </el-col>
              <el-col :span="17">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                  <el-tab-pane label="全部动态" name="a1"></el-tab-pane>
                  <el-tab-pane label="平面图" name="a2"></el-tab-pane>
                  <el-tab-pane label="效果图" name="a3"></el-tab-pane>
                  <el-tab-pane label="施工图" name="a4"></el-tab-pane>
                  <el-tab-pane label="施工交底" name="a5"></el-tab-pane>
                  <el-tab-pane label="复尺" name="a6"></el-tab-pane>
                  <el-tab-pane label="深化图纸" name="a7"></el-tab-pane>
                  <el-tab-pane label="下单" name="a8"></el-tab-pane>
                  <el-tab-pane label="验收" name="a9"></el-tab-pane>
                </el-tabs>
                <div v-if="total===0" class="order-dynamic-not">
                  暂无动态数据
                </div>
                <div class="order-dynamic-item" style="margin-top: 20px;margin-bottom: 20px" v-for="item in dynamicData">
                  <div class="photo">
                    <el-avatar shape="square" :size="50" :src="item.userphoto" style="cursor: pointer;"  />
                  </div>
                  <div class="info">
                    <div class="username"><span style="cursor: pointer;" >{{ item.username }}</span></div>
                    <div class="time">
                      <i class="el-icon-time" />
                      {{item.time}}
                    </div>
                    <div class="content">
                      <span style="color: #409EFF">#{{item.smark===1?'效果图':item.smark===2?'施工图':item.smark===3?'施工交底':item.smark===4?'复尺':item.smark===5?'深化图纸':item.smark===6?'下单':item.smark===9?'验收':'平面图'}}#</span> {{ item.remark }}
                    </div>
                    <div class="files">
                      <div v-for="f in item.filesList" class="file-item" @click="downFile(f.fileid)">
                        <i class="el-icon-document" />
                        <div class="file-name">
                          {{ f.filename }}.{{f.filetype}}
                        </div>
                      </div>
                    </div>
                    <div class="imgs">
                      <el-image
                        v-for="img in item.srcList"
                        fit="cover"
                        class="dynamic-img"
                        :src="img"
                        :preview-src-list="item.srcList"
                      />
                    </div>
                    <div class="content" style="margin-top: 10px;font-size: 12px;" v-if="(item.smark===0||item.smark===1||item.smark===2||item.smark===5)&&(item.confirmid===null||item.confirmid===undefined||item.confirmid===''||item.confirmid===0)">
<!--                      <i class="el-icon-warning" style="color: #E6A23C;font-size: 13px;"></i> 未确认-->
                      <el-button type="primary" size="mini" @click="confirmDynamic(item)">立即确认</el-button>
                    </div>
                    <div class="content" style="margin-top: 10px;font-size: 12px;" v-if="(item.smark===0||item.smark===1||item.smark===2||item.smark===5)&&item.confirmid!==null&&item.confirmid!==undefined&&item.confirmid!==''&&item.confirmid!==0">
                      <i class="el-icon-success" style="color: #67c23a;font-size: 13px;"></i> 已确认
                      <span style="color: #9aaabf;margin-left: 10px">{{ item.confirmname }} 于 {{ item.confirmtime }}</span>
                    </div>

                  </div>
                </div>
                <el-pagination
                  v-if="total>0"
                  background
                  :current-page="currentPage"
                  :page-sizes="[20, 50, 100]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                />
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getUser } from '@/utils/auth'
import { confirmDynamic, selectSidOrderDataList, selectSzBuildShopDetail, selectSzBuildShopDynamic } from '@/api/work'
import { getFileInfo } from '@/api/pub'
export default {
  name: 'delszjdDetail_homepage',
  computed: {
    user: getUser
  },
  data() {
    return {
      sid: null,
      loading: false,
      dataDetail: '',
      smark: 0,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      dynamicData: [],
      orderDataLoading: false,
      orderTableData: [],
      orderpageSize: 10,
      ordercurrentPage: 1,
      ordertotal: 0,
      activeName: 'a1',
    }
  },
  created() {
    this.sid = this.$route.params && this.$route.params.sid
    this.selectSzBuildShopDetail()
  },
  methods: {
    downFile(fileid) {
      getFileInfo({ fileid: fileid }).then(response => {
        const a = document.createElement('a')
        // a.download = response.data.dName + '.' + response.data.dType
        a.href = response.data.copyPath
        a.target = '_blank'
        a.click()
        const h = this.$createElement
        this.$msgbox({
          title: '下载提示',
          message: h('div', { attrs: { style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;' }}, [
            h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
            h('a',
              { attrs: {
                  href: response.data.copyPath,
                  target: '_blank',
                  download: `${response.data.dName}.${response.data.dType}`,
                  style: 'color: #409EFF;text-decoration:underline;'
                }}, `点击这里`),
            h('span', null, `重新下载。`)
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭',
          beforeClose: (action, instance, done) => {
            done()
          }
        }).then(action => {
        })
      }).catch(() => {})
    },
    handleClick(tab, event) {
      this.smark = tab.index
      this.currentPage = 1
      this.searchDynamic()
    },
    orderHandleSizeChange(val) {
      this.orderpageSize = val
      this.selectSidOrderDataList()
    },
    orderHandleCurrentChange(val) {
      this.ordercurrentPage = val
      this.selectSidOrderDataList()
    },
    openDetails(row) {
      this.$router.push({ path: '/work/delorder/' + row.orderid })
    },
    selectSidOrderDataList() {
      this.orderDataLoading = true
      const data = {
        sid: this.sid,
        page: this.ordercurrentPage,
        limit: this.orderpageSize
      }
      selectSidOrderDataList(data).then(response => {
        this.orderTableData = response.data
        this.ordertotal = response.total
        this.orderDataLoading = false
      }).catch(() => {

      })
    },
    selectSzBuildShopDetail() {
      this.loading = true
      const data = {
        sid: this.sid
      }
      selectSzBuildShopDetail(data).then(response => {
        this.dataDetail = response.data
        this.searchDynamic(this.dataDetail.mark)
        this.loading = false
      })
    },
    searchDynamic(n) {
      if (this.dataDetail.mark >= 6) {
        this.selectSidOrderDataList()
      }
      const data = {
        sid: this.sid,
        smark: this.smark,
        page: this.currentPage,
        limit: this.pageSize
      }
      selectSzBuildShopDynamic(data).then(response => {
        this.dynamicData = response.data
        this.total = response.total
      })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.searchDynamic(this.smark)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.searchDynamic(this.smark)
    },
    confirmDynamic(item) {
      this.$confirm(`${'是否立即确认?'}`, '确认提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        const data = {
          sdid: item.sdid,
          userid: this.user.userid,
          sid: item.sid
        }
        confirmDynamic(data).then(response => {
          this.$message({
            type: 'success',
            message: '确认成功'
          })
          this.selectSzBuildShopDetail()
          this.searchDynamic(this.smark)
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.orderHomepage-container{
  .mt{
    margin-top: 20px;
  }
  .order-info{
    width: 100%;
    margin-bottom: 20px;
    position: relative;
    .tit{
      color:#99a9bf;
    }
    .price{
      color:#F56C6C;
      font-weight: 500;
    }
    .mf{
      margin-left: 30px
    }
    .link{
      color:#409EFF;
      cursor: pointer;
      font-weight: 500;
      &:hover{
        opacity: 0.8;
      }
    }
    .file-item{
      cursor: pointer;
      background: #f6f7fa;
      color:#909399;
      padding: 10px 10px 10px 44px;
      position: relative;
      width: 100%;
      i{
        position: absolute;
        font-size: 30px;
        left: 10px;
        top:10px;
      }
      .file-name{
        width: 100%;
        height: 30px;
        font-size: 12px;
        line-height: 15px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      &:hover{
        color:#409EFF;
      }
    }
    &:last-child{
      margin-bottom: 0;
    }
  }
  .info-ellipsis{
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .order-track{
    overflow-x: auto;
    overflow-y: hidden;
    .order-track-info{
      width: 2240px;
      position: relative;
      .el-steps{
        .el-step{
          flex-basis: 160px!important;
        }
      }
    }
  }
  .order-dynamic-not{
    width: 100%;
    height: 100px;
    line-height: 100px;
    font-size: 12px;
    color:#999;
    text-align: center;
  }
  .order-dynamic-item{
    width: 100%;
    position: relative;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #f5f7fa;
    padding-left: 60px;
    padding-right: 60px;
    min-height: 60px;
    .photo{
      width: 100px;
      height: 100px;
      position: absolute;
      left: 0;
      top:0;
    }
    .info{
      position: relative;
      padding-right: 40px;
      width: 100%;
      .username{
        margin-bottom: 6px;
        span{
          &:first-child{
            font-size: 14px;
            font-weight: 500;
            margin-right: 6px;
          }
        }
      }
      .time{
        font-size: 12px;
        color:#999;
        margin-bottom: 6px;
        position: absolute;
        right: 0;
        top:4px;
      }
      .content{
        margin-bottom: 6px;
      }
      .files{
        position: relative;
        width: 100%;
        .file-item{
          cursor: pointer;
          float: left;
          background: #f6f7fa;
          color:#909399;
          padding: 10px 10px 10px 44px;
          position: relative;
          width: 200px;
          margin-right: 10px;
          margin-bottom: 6px;
          .el-icon-document{
            position: absolute;
            font-size: 30px;
            left: 10px;
            top:10px;
          }
          .file-name{
            width: 100%;
            height: 30px;
            font-size: 12px;
            line-height: 15px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .lessonplay{
            width: 100%;
            height: 100%;
            display: none;
            position: absolute;
            top:0;
            left: 0;
            background: rgba(0,0,0,0.6);
            color:#fff;
            text-align: center;
            line-height: 50px;
            span{
              margin-right: 20px;
              font-weight: bold;
              &:hover{
                color:#94c8fc;
              }
              &:last-child{
                margin-right: 0;
              }
            }
          }
          &:hover{
            .lessonplay{
              display: block;
            }
          }
        }
        .dwg{
          padding: 10px 50px 10px 44px;
          .online-view{
            width: 50px;
            position: absolute;
            right: 0;
            top:0;
          }
        }
        &:after,&:before{
          content: '';
          display: block;
          clear: both;
        }
      }
      .imgs{
        .dynamic-img{
          width:60px;
          height: 60px;
          margin-right: 10px;
          border:1px dashed #f5f7fa;
        }
      }
    }
    &:last-child{
      border-bottom: 0px;
    }
  }
  .user-item{
    color:#99a9bf;
    margin-bottom: 20px;
    font-size: 13px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    span{
      font-weight: 400;
      color: #606266;
    }
    i{
      margin-right: 5px;
    }
  }
  .menu-list{
    width: 100%;
    position: relative;
    .menu-item{
      float: left;
      width: 80px;
      margin: 4px 10px 10px 0;
      padding:10px;
      position: relative;
      border-radius: 2px;
      cursor: pointer;
      .menu-item-img{
        text-align: center;
        width: 100%;
        svg{
          width: 50px!important;
          height: 50px!important;
        }
      }
      .menu-item-name{
        width: 100%;
        text-align: center;
        padding-top: 8px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        font-size: 12px;
        font-weight: bold;
      }
      .el-badge__content{
        top: 20px!important;
        right: 30px!important;
      }
      &:hover{
        background: #f5f7fa;
      }
    }
    &:after{
      content: ' ';
      clear: both;
      display: table;
    }
  }
}
</style>
